import React, { useEffect } from "react";

import {
  Grid,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
} from "@material-ui/core";

import Chip from "../../../../components/basics/Chip";
import Btn from "../../../../components/buttons/Btn";

import { HeaderModal } from "../styles/Emissao";
import TextField from "../../../../components/basics/TextFieldErp";
import useEmissaoController from "../controllers/EmissaoController";

const ModalEmissaoVolume = ({
  modalVolumeOpen,
  setModalVolumeOpen,
  indexSize,
}) => {
  const {
    handleAddSizes,
    volQuantity,
    setVolQuantity,
    volEsp,
    setVolEsp,
    volBrand,
    setVolBrand,
    volNumber,
    setVolNumber,
    volNetWeight,
    setVolNetWeight,
    volGrossWeight,
    setVolGrossWeight,
    volError,
    handleEditSize,
  } = useEmissaoController();

  useEffect(() => {
    if (indexSize !== null) {
      handleEditSize(indexSize);
    }
    // eslint-disable-next-line
  }, []);

  const handleClose = () => {
    setModalVolumeOpen(false);
  };
  return (
    <Dialog
      fullWidth={true}
      maxWidth="md"
      open={modalVolumeOpen}
      onClose={handleClose}
      aria-labelledby="dialog-volumes"
    >
      <HeaderModal>
        <DialogTitle id="dialog-cobranca">
          <Chip label="VOLUMES" bgcolor="primary" textcolor="white" />
        </DialogTitle>
      </HeaderModal>
      <DialogContent>
        <Grid container>
          <Grid container spacing={2}>
            <Grid item sm={2}>
              <TextField
                value={volQuantity}
                setValue={setVolQuantity}
                size="small"
                label="Quantidade"
                mask="integer"
                error={volError.volQuantity ? true : false}
                helperText={volError.volQuantity || ""}
              />
            </Grid>
            <Grid item sm={6}>
              <TextField
                value={volEsp}
                setValue={setVolEsp}
                size="small"
                label="Espécie"
              />
            </Grid>
            <Grid item sm={4}>
              <TextField
                value={volBrand}
                setValue={setVolBrand}
                size="small"
                label="Marca"
              />
            </Grid>
            <Grid item sm={4}>
              <TextField
                value={volNumber}
                setValue={setVolNumber}
                size="small"
                label="Numeração"
              />
            </Grid>
            <Grid item sm={4}>
              <TextField
                value={volNetWeight}
                setValue={setVolNetWeight}
                size="small"
                label="Peso Liquido (KG)"
                mask="decimal"
                decimals={3}
                error={volError.volNetWeight ? true : false}
                helperText={volError.volNetWeight || ""}
              />
            </Grid>
            <Grid item sm={4}>
              <TextField
                value={volGrossWeight}
                setValue={setVolGrossWeight}
                size="small"
                decimals={3}
                label="Peso Bruto (KG)"
                mask="decimal"
              />
            </Grid>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Btn
          onClick={() => handleAddSizes(setModalVolumeOpen, indexSize)}
          label="incluir"
        />
        <Btn
          bgcolor="tertiary"
          hovercolor="blue"
          onClick={handleClose}
          label="cancelar"
        />
      </DialogActions>
    </Dialog>
  );
};

export default ModalEmissaoVolume;
